var React = require('react');

function Enterprise (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"48","height":"48","rx":"8","fill":"white","key":0}),React.createElement("mask",{"id":"mask0_5583_603","style":{"maskType":"alpha"},"maskUnits":"userSpaceOnUse","x":"12","y":"12","width":"24","height":"24","key":1},React.createElement("rect",{"x":"12","y":"12","width":"24","height":"24","fill":"#D9D9D9"})),React.createElement("g",{"mask":"url(#mask0_5583_603)","key":2},React.createElement("path",{"d":"M15 33V19H19V15H29V23H33V33H25V29H23V33H15ZM17 31H19V29H17V31ZM17 27H19V25H17V27ZM17 23H19V21H17V23ZM21 27H23V25H21V27ZM21 23H23V21H21V23ZM21 19H23V17H21V19ZM25 27H27V25H25V27ZM25 23H27V21H25V23ZM25 19H27V17H25V19ZM29 31H31V29H29V31ZM29 27H31V25H29V27Z","fill":"#064861"}))]);
}

Enterprise.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = Enterprise;

Enterprise.default = Enterprise;
